import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  FormGroup,
  Label,
  Input,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import { v4 as uuidv4 } from "uuid";
import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
}));

function FacturasCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_SERIES = process.env.REACT_APP_URL_SERIES;
  const URL_TIMBRAR = process.env.REACT_APP_URL_TIMBRAR;
  const URL_FACTURAS = process.env.REACT_APP_URL_FACTURAS;
  const URL_ARTICULOS_SURTIDOS = process.env.REACT_APP_URL_ARTICULOS_SURTIDOS;
  const URL_SURTIDOS = process.env.REACT_APP_URL_SURTIDOS;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_EMPRESAS = process.env.REACT_APP_URL_EMPRESAS;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);
  const [fecha, setFecha] = useState(hoy);
  const [observaciones, setObservaciones] = useState("NA");
  
  const [timbresDisponibles, setTimbresDisponibles] = useState(0);

  const [subTotal, setSubTotal] = useState(0);
  const [iva, setIva] = useState(0);
  const [total, setTotal] = useState(0);
  const [totalCant, setTotalCant] = useState(0);

  const [surtidos, setSurtidos] = useState([]);

  const [clientes, setClientes] = useState([]);
  const [empresas, setEmpresas] = useState([]);
  const [colaboradores, setColaboradores] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  const [selectedEmpresa, setSelectedEmpresa] = useState("");
  const [selectedColaborador, setSelectedColaborador] = useState("");

  const [cpEmpresa, setCpEmpresa] = useState("");
  const [rfcEmpresa, setRfcEmpresa] = useState("");
  const [nombreEmpresa, setNombreEmpresa] = useState("");
  const [regFiscalEmpresa, setRegFiscalEmpresa] = useState("");

  const [condicionesPagoSATCliente, setCondicionesPagoSATCliente] = useState("")
  const [formaPagoSATCliente, setFormaPagoSATCliente] = useState("")
  const [metodoPagoSATCliente, setMetodoPagoSATCliente] = useState("")
  const [rfcCliente, setRfcCliente] = useState("")
  const [nombreCliente, setNombreCliente] = useState("")
  const [usoCFDICliente, setUsoCFDICliente] = useState("")
  const [regFiscalCliente, setRegFiscalCliente] = useState("")
  const [cpCliente, setCpCliente] = useState("")

  const [serie, setSerie] = useState("")

  const classes = useStyles();
  const [inputFields, setInputFields] = useState([]);

  const [surtidosData, setSurtidosData] = useState([]);
  const ordenTallas = ["EXTRA CHICA", "CHICA", "M", "MEDIANA", "GRANDE", "EXTRA GRANDE", "VARIOS", "INDIVIDUAL", "MATRIMONIAL", "QUEEN", "KING", "32", "34", "36", "38", "40", "42"];

  const [validaBoton, setValidaBoton] = useState(true);

  useEffect(() => {
    axios
    .get(`${URL_CLIENTES}`, { 
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allClientes = res.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });

      axios
      .get(`${URL_SERIES}Timbres`, { 
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((res) => {
          const allTimbres = res.data;
          setTimbresDisponibles(allTimbres[0].folio);
        })
        .catch((err) => {
          console.log(err);
        });
     
      axios
      .get(`${URL_EMPRESAS}`, { 
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((res) => {
          const allEmpresas = res.data;
          setEmpresas(allEmpresas);
        })
        .catch((err) => {
          console.log(err);
        });
        axios
        .get(`${URL_COLABORADORES}`, { 
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          })
          .then((res) => {
            const allColaboradores = res.data;
            setColaboradores(allColaboradores);
          })
          .catch((err) => {
            console.log(err);
          });
  }, []);

  const saveFacturaNuevo = async (event) => {
    event.preventDefault();
    if(timbresDisponibles > 0){
    Swal.fire({
      title: "Estas seguro?",
      text: "Se guardará la Factura!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, guardar!",
    }).then(async (result) => {
    if (
      result.isConfirmed &&
      subTotal > 0 &&
      total > 0
    ) {
      setValidaBoton(false);
      toggleProgreso();
     
      let totalArticulos =
        inputFields.length 
      try {
        await axios
          .post(
            URL_FACTURAS,
            {
              fecha,
              observaciones,
              totalCantidad:totalCant,
              subTotal: (subTotal).toFixed(2),
              iva: (iva).toFixed(2),
              total: (total).toFixed(2),
              abonos:0,
              saldo: (total).toFixed(2),
              pagado:"No",
              descuentoPorcentaje1:0,
              descuentoNumero1:0,
              descuentoConcepto1:"NA",
              descuentoPorcentaje2:0,
              descuentoNumero2:0,
              descuentoConcepto2:"NA",
              empresas: selectedEmpresa,
              clientes: selectedCliente,
              colaboradores: selectedColaborador,
              timbre:"No",
              currency: "MXN",
              cfdiType:"I",
              
              serie,
              expeditionPlace: cpEmpresa,

              rfcEmpresa,
              nombreEmpresa,
              regFiscalEmpresa,

              condicionesPagoSATCliente,
              formaPagoSATCliente,
              metodoPagoSATCliente,
              rfcCliente,
              nombreCliente,
              usoCFDICliente,
              regFiscalCliente,
              cpCliente,

              numeroPagos:0,

            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((data) => {

            inputFields.map((w) => {
              axios
                .patch(
                  `${URL_SURTIDOS}Factura/${w.surtidos}`,
                  {
                    facturas: data.data._id,
                    facturado: "Si",
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                )
                .then(() => {
                  totalArticulos = totalArticulos - 1;
                  if (totalArticulos == 0) {

                    axios.post(`${URL_TIMBRAR}Factura`,{
                      facturas: data.data._id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    ).then(()=>{

                      axios
                      .post(
                        URL_LOGS,
                        {
                          tipo: "Crear Factura",
                          detalle: `Fecha Factura ${fecha} ${data.data.idFactura}`,
                          user: user.id,
                        },
                        {
                          headers: {
                            Authorization: `Bearer: ${localStorage.getItem(
                              "app_token"
                            )}`,
                          },
                        }
                      )
                      .then(() => {
                        Swal.fire("Good job!", "Creado con exito", "success");
                        setTimeout(() => {
                          window.location.reload();
                        }, 1000);
                      })
                      .catch((error) => {
                        Swal.fire({
                          icon: "error",
                          title: "Oops...",
                          text: "Something went wrong!",
                          footer: `${error.response.data}`,
                        });
                        console.log(error);
                        setValidaBoton(true);
                        setModalProgreso(false)
                      });

                    }).catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                      setValidaBoton(true);
                      setModalProgreso(false)
                    });
                  }
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                  setValidaBoton(true);
                  setModalProgreso(false)
                });
            });

          
          })
          // Catch primer then
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data.message}`,
            });
            console.log(error);
            setValidaBoton(true);
            setModalProgreso(false)
          });
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          // footer: `${error.response.data}`,
        });
        console.log(error);
        setValidaBoton(true);
        setModalProgreso(false)
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `Faltan Datos`,
      });
      setValidaBoton(true);
      setModalProgreso(false)
    }
  })
}else{
  Swal.fire({
    icon: "error",
    title: "Oops...",
    text: "Something went wrong!",
    footer: `No cuenta con timbres disponibles`,
  });
  setValidaBoton(true);
  setModalProgreso(false)
}
  };

  
  const handleAddFields = () => {
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        surtidos: "",
        idSurtido: "",
        total: 0,
        totalCantidad: 0,
      },
    ]);
  };


  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);

    let din = values.map((c) => parseFloat(c.total));
    let TD = din.reduce((t, total, index) => t + total, 0);
    setSubTotal(TD);

    let iva = (TD) * 0.16;
    setIva(iva);

    let total = (TD) + iva;
    setTotal(total);
  };

function BuscaCliente(cliente) {

  setSelectedCliente(cliente._id);
  setSurtidosData([]);

  setInputFields([
    {
      id: uuidv4(),
      surtidos: "",
      idSurtido: "",
      total: 0,
      totalCantidad: 0,
    },
  ]);

  if (!cliente) return;

  setCondicionesPagoSATCliente(cliente.condicionesPagoSAT);
  setRfcCliente(cliente.RFC);
  setNombreCliente(cliente.razon_social);
  setUsoCFDICliente(cliente.usoCFDI);
  setRegFiscalCliente(cliente.regFiscal);
  setCpCliente(cliente.cp);
  setSelectedColaborador(cliente.contacto?.[0]?._id || "");

  if (cliente.metodoPagoSAT !== "PPD") {
    setFormaPagoSATCliente(cliente.formaPagoSAT);
    setMetodoPagoSATCliente(cliente.metodoPagoSAT);
  } else {
    setFormaPagoSATCliente("99");
    setMetodoPagoSATCliente(cliente.metodoPagoSAT);
  }

  // --- Surtidos (usa el _id del cliente) ---
  if (cliente._id && selectedEmpresa) {
    axios
      .get(`${URL_SURTIDOS}Facturacion/${cliente._id}/${selectedEmpresa}`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((res) => {
        const allSurtidos = res.data || [];
        const dataFinal = allSurtidos.map((a) => ({
          id: uuidv4(),
          surtidos: a._id,
          idSurtido: a.idSurtido,
          total: a.subTotal,
          totalCantidad: a.totalCantidad,
          articulo: a.articulos?.[0]?.codigo || "",
        }));
        setSurtidos(dataFinal);
      })
      .catch(console.log);
  }
}


  function BuscaEmpresa(event) {
    setSelectedEmpresa(event.target.value)
    if(event.target.value == "6939d1fcc1ac4ddbda8c0b74"){
      setSerie("B")
    }else if(event.target.value == "64554028db17c2f7f0a771c2"){
      setSerie("A")
    }

    empresas.map((a)=>{
      if(a._id == event.target.value){
        setCpEmpresa(a.cp)
        setRfcEmpresa(a.rfc)
        setNombreEmpresa(a.razonSocial)
        setRegFiscalEmpresa(a.regimenFiscal)
      }
    })
    setInputFields(
    [{
      id: uuidv4(),
      surtidos: "",
      idSurtido: "",
      total: 0,
      totalCantidad: 0,
    }]
    );
    if(event.target.value != "" && selectedCliente != ""){
      axios
      .get(`${URL_SURTIDOS}Facturacion/${selectedCliente}/${event.target.value}`, { 
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((res) => {
          const allSurtidos = res.data;
          let arrayTabla = allSurtidos.map((a)=>{
            return {
              id: uuidv4(),
              surtidos: a._id,
              idSurtido: a.idSurtido,
              total: a.subTotal,
              totalCantidad: a.total_cantidad,
              articulo: a.articulos[0].codigo
            }
          })
          let dataFinal = Object.values(arrayTabla);
          setSurtidos(dataFinal);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  // function BuscaColaborador(event) {
  //   setSelectedColaborador(event.target.value)
  //   setInputFields(
  //   [{
  //     id: uuidv4(),
  //     surtidos: "",
  //     idSurtido: "",
  //     total: 0,
  //     totalCantidad: 0,
  //   }]
  //   );
  //   if(event.target.value != "" && selectedCliente != "" && selectedEmpresa != ""){
  //     axios
  //     .get(`${URL_SURTIDOS}Facturacion/${selectedCliente}/${event.target.value}/${selectedEmpresa}`, { 
  //         headers: {
  //           Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  //         },
  //       })
  //       .then((res) => {
  //         const allSurtidos = res.data;
  //         let arrayTabla = allSurtidos.map((a)=>{
  //           return {
  //             id: uuidv4(),
  //             surtidos: a._id,
  //             idSurtido: a.idSurtido,
  //             total: a.subTotal,
  //             totalCantidad: a.total_cantidad,
  //           }
  //         })
  //         let dataFinal = Object.values(arrayTabla);
  //         setSurtidos(dataFinal);
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //       });
  //   }
  // }

  // async function BuscaSurtido(id, event) {
  //   if (
  //     inputFields.filter((e) => e.surtidos == event.target.value).length >
  //     0
  //   ) {
  //     Swal.fire({
  //       icon: "error",
  //       title: "Oops...",
  //       text: "El surtido ya fue capturado!",
  //       showConfirmButton: false,
  //     });
  //     const newInputFields = inputFields.map((i) => {
  //       if (id === i.id) {
  //         i.surtidos = "";
  //       }
  //       return i;
  //     });
  //     setInputFields(newInputFields);
  //   } else {
  //     await axios
  //     .get(`${URL_ARTICULOS_SURTIDOS}/surtido/${idPDFOC}`, {
  //       headers: {
  //         Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  //       },
  //     })
  //     .then((response) => {
  //       let allArticulosSurtido = response.data;
  //       let colorTallaCantidad = {};
  //       let precio = response.data[0].articulosPedido[0].precio;

  //       allArticulosSurtido.forEach((a) => {
  //         const color = a.colores[0].name;
  //         const talla = a.tallas[0].name;
  //         const cantidad = a.cantidad;

  //         if (!colorTallaCantidad[talla]) {
  //           colorTallaCantidad[talla] = {};
  //         }
  //         if (!colorTallaCantidad[talla][color]) {
  //           colorTallaCantidad[talla][color] = 0;
  //         }
  //         colorTallaCantidad[talla][color] += cantidad;
  //       });

  //       const tallas = Object.keys(colorTallaCantidad).sort((a, b) => {
  //         const indexA = ordenTallas.indexOf(a);
  //         const indexB = ordenTallas.indexOf(b);
        
  //         // Si alguna talla no está en el orden definido, coloca al final
  //         return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB);
  //       });
  //       const colores = [
  //         ...new Set(allArticulosSurtido.map((a) => a.colores[0].name)),
  //       ].sort();
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     })

  //     surtidos.map((a) => {
  //       if (a.surtidos == event.target.value) {
  //         console.log("holaa", a)
  //         let surtidos = a.surtidos;
  //         let idSurtido = a.idSurtido;
  //         let total = a.total
  //         let totalCantidad = a.totalCantidad
  //         handleChangeInputArticulo(id, surtidos, idSurtido, total, totalCantidad);
  //       }
  //     });
  //   }
  // }

  // async function BuscaSurtido(id, event) {
  //   setSurtidosData([])
  
  //   if (inputFields.some((e) => e.surtidos === event.target.value)) {
  //     Swal.fire({
  //       icon: "error",
  //       title: "Oops...",
  //       text: "El surtido ya fue capturado!",
  //       showConfirmButton: false,
  //     });
  
  //     setInputFields(inputFields.map((i) => (i.id === id ? { ...i, surtidos: "" } : i)));
  //     return;
  //   }
  
  //   try {
  //     surtidos.map((a) => {
  //        if (a.surtidos == event.target.value) {
  //          console.log("holaa", a)
  //          let surtidos = a.surtidos;
  //          let idSurtido = a.idSurtido;
  //          let total = a.total
  //          let totalCantidad = a.totalCantidad
  //          handleChangeInputArticulo(id, surtidos, idSurtido, total, totalCantidad);
  //        }
  //      });
       
  //     const response = await axios.get(`${URL_ARTICULOS_SURTIDOS}/surtido/${event.target.value}`, {
  //       headers: {
  //         Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  //       },
  //     });
  
  //     if (!response.data.length) {
  //       console.warn("La API no devolvió datos");
  //       return;
  //     }
  
  //     let allArticulosSurtido = response.data;
  //     let colorTallaCantidad = {};
  
  //     allArticulosSurtido.forEach((a) => {
  //       const color = a.colores[0].name;
  //       const talla = a.tallas[0].name;
  //       const cantidad = a.cantidad;
  
  //       if (!colorTallaCantidad[talla]) {
  //         colorTallaCantidad[talla] = {};
  //       }
  //       if (!colorTallaCantidad[talla][color]) {
  //         colorTallaCantidad[talla][color] = 0;
  //       }
  //       colorTallaCantidad[talla][color] += cantidad;
  //     });
  
  //     const tallas = Object.keys(colorTallaCantidad).sort((a, b) => {
  //       const indexA = ordenTallas.indexOf(a);
  //       const indexB = ordenTallas.indexOf(b);
  //       return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB);
  //     });
  
  //     const colores = [...new Set(allArticulosSurtido.map((a) => a.colores[0].name))].sort();
  
  //     setSurtidosData(
  //       tallas.map((talla) => ({
  //         talla,
  //         colores: colores.map((color) => ({
  //           color,
  //           cantidad: colorTallaCantidad[talla][color] || 0,
  //         })),
  //       }))
  //     );
  
  
  
  //   } catch (err) {
  //     console.error("Error en la petición a la API:", err);
  //   }
  // }

async function BuscaSurtido(id, event) {
  const surtidoValue = event?.target?.value;

  // Validar que surtidoValue no sea null o vacío
  if (!surtidoValue) {
    console.warn("No se recibió un valor de surtido válido.");
    return;
  }

  if (inputFields.some((e) => e.surtidos === surtidoValue)) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "El surtido ya fue capturado!",
      showConfirmButton: false,
    });

    setInputFields(inputFields.map((i) => (i.id === id ? { ...i, surtidos: "" } : i)));
    return;
  }

  try {
    surtidos.forEach((a) => {
      if (a.surtidos === surtidoValue) {
        const { surtidos, idSurtido, total, totalCantidad } = a;
        handleChangeInputArticulo(id, surtidos, idSurtido, total, totalCantidad);
      }
    });

    const response = await axios.get(`${URL_ARTICULOS_SURTIDOS}/surtido/${surtidoValue}`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    });

    if (!response.data.length) {
      console.warn("La API no devolvió datos para el surtido:", surtidoValue);
      return;
    }

    const allArticulosSurtido = response.data;
    const colorTallaCantidad = {};

    allArticulosSurtido.forEach((a) => {
      const color = a.colores?.[0]?.name;
      const talla = a.tallas?.[0]?.name;
      const cantidad = a.cantidad;

      if (!color || !talla) return; // Previene errores si no hay color o talla

      if (!colorTallaCantidad[talla]) colorTallaCantidad[talla] = {};
      if (!colorTallaCantidad[talla][color]) colorTallaCantidad[talla][color] = 0;
      colorTallaCantidad[talla][color] += cantidad;
    });

    const tallas = Object.keys(colorTallaCantidad).sort((a, b) => {
      const indexA = ordenTallas.indexOf(a);
      const indexB = ordenTallas.indexOf(b);
      return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB);
    });

    const colores = [...new Set(allArticulosSurtido.map((a) => a.colores?.[0]?.name).filter(Boolean))].sort();

    setSurtidosData((prevData) => [
      ...prevData,
      {
        surtido: surtidoValue,
        data: tallas.map((talla) => ({
          talla,
          colores: colores.map((color) => ({
            color,
            cantidad: colorTallaCantidad[talla][color] || 0,
          })),
        })),
      },
    ]);
  } catch (err) {
    console.error("Error en la petición a la API:", err);
  }
}


  

  const handleChangeInputArticulo = (id, surtidos, idSurtido, total, totalCantidad) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.surtidos = surtidos;
        i.idSurtido = idSurtido;
        i.total = total;
        i.totalCantidad = totalCantidad
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };


  function ActualizaTotales() {

    let din = inputFields.map((c) => parseFloat(c.total));
    let TD = din.reduce((t, total, index) => t + total, 0);
    setSubTotal(TD);

    let tcan = inputFields.map((c) => parseFloat(c.totalCantidad));
    let TDCan = tcan.reduce((t, total, index) => t + total, 0);
    setTotalCant(TDCan);

    let iva = (TD) * 0.16;
    setIva(iva);

    let total = (TD) + iva;
    setTotal(total);

  }

  const options = clientes.map((option) => {
    const junta = option.razon_social + " " + option.nombre_comercial;
    const firstLetter = option.razon_social[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  }); 

  return (
    <>
      <Header />
      <br />
      <br />
      {user.facturasFiscal ? (
        <div className="card container col-10">
          <h3 align="center">Nuevo Factura</h3>
          <Form onSubmit={saveFacturaNuevo}>
            <Row>
            <Col md={2}>
                <Label>Timbres Disponibles</Label>
                <Input
                  type="text"
                  value={timbresDisponibles}
                  required
                  disabled
                />
              </Col>
            </Row>
            <Row>
              <Col md={2}>
                <Label>Fecha Factura</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fecha}
                  required
                  disabled
                />
              </Col>
              <Col md={2}>
                <Label>Empresa</Label>
                    <Input
                      name="empresa"
                      type="select"
                      value={selectedEmpresa}
                      required
                      onChange={(event) => {
                        BuscaEmpresa(event);
                      }}
                    >
                      <option value="">Selecciona</option>
                      {empresas
                        .sort((a, b) =>
                        a.name > b.name ? 1 : -1
                      )
                      .map((a) => {
                        if(a.listoFacturar == "Si" && a.is_active == "Si"){
                          return (
                            <option value={a._id}>{a.name}</option>
                          );}
                      })}
                    </Input>
                  </Col>

                  <Col md={2}>
                <Label>Busca Cliente</Label>
                 <Autocomplete
                                    size="small"
                                    value={selectedCliente}
                                    onChange={(event, selectedCliente) => {
                                      if (selectedCliente) {
                                        BuscaCliente(selectedCliente);
                                      }
                                    }}
                                    options={options.sort(
                                      (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                                    )}
                                    groupBy={(option) => option.firstLetter}
                                    getOptionLabel={(option) => option.junta}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        label="Selecciona"
                                        variant="outlined"
                                      />
                                    )}
                                    renderOption={(option) => (
                                      <React.Fragment>
                                       {option.razon_social} / {option.nombre_comercial}  
                                      </React.Fragment>
                                    )}
                                  />
                  </Col>
 <Col md={2}>
                <Label>Cliente</Label>
                    <Input
                      type="text"
                      placeholder="Cliente"
                      value={nombreCliente}
                      required
                      disabled
                    />
                  </Col>

                  <Col md={2}>
                <Label>Serie</Label>
                    <Input
                      type="select"
                      value={serie}
                      required
                      disabled
                      // onChange={(event) => {
                      //   setSerie(event.target.value);
                      // }}
                    >
                      <option value="">Selecciona</option>
                      <option value="A">A</option>
                      <option value="B">B</option>
                    </Input>
                  </Col>
                  <Col md={2}>
                <Label>Forma Pago Fiscal</Label>
                <Input
                  type="select"
                  value={formaPagoSATCliente}
                  required
                  onChange={(e) => {
                    setFormaPagoSATCliente(e.target.value);
                  }}
                >
              <option value="">Selecciona</option>
              <option value="01"> 01 Efectivo</option>
              <option value="02"> 02 Cheque nominativo</option>
              <option value="03"> 03 Transferencia electrónica de fondos</option>
              <option value="04"> 04 Tarjeta de crédito</option>
              <option value="05"> 05 Monedero electrónico</option>
              <option value="06"> 06 Dinero electrónico</option>
              <option value="08"> 08 Vales de despensa</option>
              <option value="12"> 12 Dación en pago</option>
              <option value="13"> 13 Pago por subrogación</option>
              <option value="14"> 14 Pago por consignación</option>
              <option value="15"> 15 Condonación</option>
              <option value="17"> 17 Compensación</option>
              <option value="23"> 23 Novación</option>
              <option value="24"> 24 Confusión</option>
              <option value="25"> 25 Remisión de deuda</option>
              <option value="26"> 26 Prescripción o caducidad</option>
              <option value="27"> 27 A satisfacción del acreedor</option>
              <option value="28"> 28 Tarjeta de débito</option>
              <option value="29"> 29 Tarjeta de servicios</option>
              <option value="30"> 30 Aplicación de anticipos</option>
              <option value="31"> 31 Intermediario de pagos</option>
              <option value="99"> 99 Por definir</option>
                </Input>
              </Col>
                  </Row>
             <Row>
              <Col md={4}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Observaciones
                </Label>
                <Input
                  type="text"
                  placeholder="Observaciones"
                  value={observaciones}
                  required
                  onChange={(e) => {
                    setObservaciones(e.target.value);
                  }}
                />
              </Col>
            </Row>


            <Row>
              <Col md={3}>
                <Label className="mr-sm-2">Nota</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Precio</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Total</Label>
              </Col>
            </Row>
{inputFields.map((inputField) => (
  <div key={inputField.id}>
    <Row>
      <Col md={3}>
        <Input
          bsSize="sm"
          name="surtidos"
          type="select"
          value={inputField.surtidos}
          required
          onChange={(event) => {
            BuscaSurtido(inputField.id, event);
          }}
        >
          <option value="">Selecciona</option>
          {surtidos
            .sort((a, b) => (a.idSurtido > b.idSurtido ? 1 : -1))
            .map((a) => (
              <option key={a.surtidos} value={a.surtidos}>
                Surt: {a.idSurtido} Art: {a.articulo} Cant: {a.totalCantidad}
              </option>
            ))}
        </Input>
      </Col>

      <Col md={1} className="d-flex align-items-center">
        <h6>
          {new Intl.NumberFormat("es-MX", {
            style: "currency",
            currency: "MXN",
          }).format(inputField.total / inputField.totalCantidad)}
        </h6>
      </Col>

      <Col md={1} className="d-flex align-items-center">
        <h6>
          {new Intl.NumberFormat("es-MX", {
            style: "currency",
            currency: "MXN",
          }).format(inputField.total)}
        </h6>
      </Col>

      <Col>
        <Button
          size="sm"
          color="danger"
          disabled={inputFields.length === 1}
          onClick={() => handleRemoveFields(inputField.id)}
          tabIndex="-1"
        >
          <i className="fas fa-minus"></i>
        </Button>
        <Button
          size="sm"
          color="info"
          onClick={handleAddFields}
          tabIndex="-1"
        >
          <i className="fas fa-plus"></i>
        </Button>
      </Col>
    </Row>

    {/* Tabla de surtido asociada a este input */}
    {surtidosData
      .filter((tabla) => tabla.surtido === inputField.surtidos)
      .map((tabla, idx) => (
        <>
        <div key={idx} className="container mt-3">
          <h5>Detalle:</h5>
          <table className="table table-striped">
            <thead>
              <tr>
                <th>Talla</th>
                {tabla.data[0]?.colores.map((c, index) => (
                  <th key={index}>{c.color}</th>
                ))}
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {tabla.data.map((fila, index) => {
                const totalFila = fila.colores.reduce((sum, c) => sum + c.cantidad, 0);
                return (
                  <tr key={index}>
                    <td>{fila.talla}</td>
                    {fila.colores.map((c, i) => (
                      <td key={i}>{c.cantidad}</td>
                    ))}
                    <td><strong>{totalFila}</strong></td>
                  </tr>
                );
              })}

              {/* Fila de Totales por Columna */}
              <tr>
                <td><strong>Total</strong></td>
                {tabla.data[0]?.colores.map((_, i) => {
                  const totalColumna = tabla.data.reduce(
                    (sum, fila) => sum + fila.colores[i].cantidad,
                    0
                  );
                  return <td key={i}><strong>{totalColumna}</strong></td>;
                })}
                <td>
                  <strong>
                    {tabla.data.reduce(
                      (sum, fila) => sum + fila.colores.reduce((s, c) => s + c.cantidad, 0),
                      0
                    )}
                  </strong>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style={{ marginBottom: '40px' }}></div> 
        </>
      ))}
  </div>
))}



       
            <br />
            <br />
            <Row>
            <Col>
            <Label className="mr-sm-2">Subtotal</Label>
            <Input
              type="number"
              value={subTotal}
              disabled
            />
            </Col>
            <Col>
            <Label className="mr-sm-2">IVA</Label>
            <Input
              type="number"
              value={iva}
              disabled
            />
            </Col>
            <Col>
            <Label className="mr-sm-2">Total</Label>
            <Input
              type="number"
              value={total}
              disabled
            />
            </Col>
            </Row>

            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
            <Button
              href="/ListadoFacturas"
              className="btn btn-danger"
              id="botonListado"
            >
              Regresar
            </Button>
          </Form>
          <br />
          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                {" "}
                Este proceso puede tardar varios segundos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default FacturasCreate;
